var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimeFill = function SvgTimeFill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63598 5.63616C3.94815 7.32399 2.99994 9.61317 2.99994 12.0001C2.99994 14.3871 3.94815 16.6763 5.63598 18.3641C7.32381 20.0519 9.61299 21.0001 11.9999 21.0001C14.3869 21.0001 16.6761 20.0519 18.3639 18.3641C20.0517 16.6763 20.9999 14.3871 20.9999 12.0001C20.9999 9.61317 20.0517 7.32399 18.3639 5.63616C16.6761 3.94833 14.3869 3.00012 11.9999 3.00012C9.61299 3.00012 7.32381 3.94833 5.63598 5.63616ZM11.2499 7.50012V11.2501C11.2499 12.0785 11.9215 12.7501 12.7499 12.7501H14.9999V11.2501H12.7499V7.50012H11.2499Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimeFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "time-fill.feab28e9ac580b933fd5f3407226648c.svg";